/** Ids de empleado comparables con `===` / `Set.has` (el `<select>` devuelve string). */
export const normalizeEmployeeId = (id) => {
	if (id == null || id === "") return null;
	const numericId = Number(id);
	return Number.isFinite(numericId) ? numericId : null;
};

export const normalizeEmployeeIds = (ids) => {
	if (!Array.isArray(ids)) return [];
	const seen = new Set();
	const result = [];
	ids.forEach((id) => {
		const numericId = normalizeEmployeeId(id);
		if (numericId == null || seen.has(numericId)) return;
		seen.add(numericId);
		result.push(numericId);
	});
	return result;
};
